const startAndroidApp = () => {
  window.location.href = 'https://www.bigizone.co.il/redirects/googleplay_redirect.html';
}
export default startAndroidApp;


// WEBPACK FOOTER //
// ./src/js/lib/startandroidapp.js